import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import DInputPassword from '../DInputPassword';
import PasswordChecksList from './PasswordCheckList';
const DEFAULT_VALIDATION_MESSAGES = {
    number: 'At least one number',
    lowercaseLetter: 'At least one lowercase letter',
    uppercaseLetter: 'At least one uppercase letter',
    especialChar: 'At least one of these special characters: ~!@#$^*-_=[]{}|;,.?',
    notMatch: 'The password confirmation and the new password do not match.',
};
const DEFAULT_ENABLED_CHECKS = ['uppercase', 'lowercase', 'number', 'specialChar'];
export default function DPasswordStrengthMeter({ id, label = 'Password', placeholder, value = '', name, disabled = false, invalid = false, validationMessages = DEFAULT_VALIDATION_MESSAGES, enabledChecks = DEFAULT_ENABLED_CHECKS, className, style, dataAttributes, onChange, }) {
    const [password, setPassword] = useState(value);
    useEffect(() => {
        setPassword(value);
    }, [value]);
    const handleChange = (newValue) => {
        setPassword(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    return (_jsxs("div", Object.assign({ className: className, style: style }, dataAttributes, { children: [_jsx(DInputPassword, { id: id, label: label, placeholder: placeholder, value: password, name: name, disabled: disabled, invalid: invalid, onChange: handleChange }), _jsx(PasswordChecksList, { password: password, validationMessages: validationMessages, enabledChecks: enabledChecks })] })));
}
//# sourceMappingURL=DPasswordStrengthMeter.js.map